export const getFormattedPrice = (price: number): string => {
  const numberParts = price.toString().split('.');
  numberParts[0] = numberParts[0].replace(/(\d)(?=(\d{2})+(\d)(?!\d))/g, '$1 ');

  return numberParts.join('.');
}

export const isSingular = (input: number | string): boolean => Number(input) < 2;
